<style type="text/css" media="print">
  @page { size: portrait; }
</style>

<div class="only-print page-break" id="print-ts-{{application.id}}">
  <img ng-src="{{$root.parametros.imagem_report_url}}" ng-if="$root.parametros.imagem_report_url" class="logo">
  <div class="title-recomendacoes">
    {{ 'Tratamento de sementes' | capitalize}}
  </div>
  <br>
  <p>
    <strong>Iniciada em: </strong>
    {{::application.data_hora_inicio | date: 'dd/MM/yyyy'}}
    <br>
    <strong>Encerrada em: </strong>
    {{::application.data_hora_fim | date: 'dd/MM/yyyy'}}
    <br>
  </p>
  <strong>Propriedade: </strong>{{::application.propriedade.descricao | uppercase}}
  <br />
  <strong>Cultura: </strong>{{::application.item_estoque_origem.atividade.descricao | uppercase}}

  <div>
    <br>
    <span ng-show="application.tratamento">
      <b>{{application.tratamento}}</b>
      <br />
    </span>
    <br />
    <table class="table table-striped table-condensed no-margin">
      <thead>
        <tr>
          <th class="text-center">Cultivar de Origem</th>
          <th class="text-center">Cultivar de Destino</th>
          <th class="text-center">
            Qtde&nbsp;<span ng-if="!recomendacaoSemeadura.isCulturaPorUnidade">({{application.unidade_destino.abreviatura}})</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-center">{{application.item_estoque_origem.descricao}}</td>
          <td class="text-center">{{application.item_estoque_destino.descricao}}</td>
          <td class="text-center">{{application.quantidade | number:2}}</td>
        </tr>
      </tbody>
    </table>
    <br />
    <div class="print-table-insumo">
      <table class="table table-striped table-condensed">
        <thead>
          <tr>
            <th>Produto</th>
            <th class="text-right">Quantidade</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="produto in application.itens" ng-show="produto.item_estoque.descricao != application.item_estoque_origem.descricao">
            <td>{{produto.item_estoque.descricao}}</td>
            <td class="text-right">{{produto.quantidade | number: 3}} {{produto.unidade.abreviatura}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <p class="list-group-item-text" ng-show="application.observacoes">
    <strong>Observação: </strong> {{::application.observacoes}}
  </p>

  <div class="signatures">
    <print-signature label="Recomendante" name="application.recommendation.usuario.nome_completo"></print-signature>
    <print-signature label="Responsável"></print-signature>
    <print-signature label="Aplicador" name="application.allData.usuario.nome_completo"></print-signature>
  </div>
</div>
